import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Instagram, ArrowUpRight } from 'lucide-react';

const Footer = () => {
  const linkSections = [
    {
      title: 'Explore',
      links: [
        { name: 'About', path: '/about' },
        { name: 'Events Calendar', path: '/events' },
        { name: 'Journey So Far', path: '/journey' },
        { name: 'Get In Touch', path: '/contact' },
      ],
    },
    {
      title: 'Legal',
      links: [{ name: 'Privacy Policy', path: '/privacy' }],
    },
  ];

  return (
    <footer className="relative surface-1 border-t border-white/8 overflow-hidden" data-testid="site-footer">
      <div className="absolute inset-0 bg-grid-pattern opacity-40 pointer-events-none" />
      <div className="absolute -bottom-40 left-1/2 -translate-x-1/2 w-[900px] h-[500px] bg-radial-teal opacity-30 pointer-events-none" />

      <div className="dark-content-container relative pt-20 pb-10">
        {/* Top: Logo & tagline */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 pb-16 border-b border-white/8">
          <div className="lg:col-span-5">
            <img src="/deft-logo.jpg" alt="Deft Experiences" className="h-16 mb-6" />
            <p className="text-3xl md:text-4xl font-display font-light text-white leading-snug mb-3">
              Alchemy for the<br />
              <span className="text-[#64C8FF]">Ambitious</span>
            </p>
            <p className="body-medium text-white/55 max-w-md">
              Curated, invite-only experiences for ambitious individuals.
            </p>
          </div>

          {/* Link columns */}
          <div className="lg:col-span-5 grid grid-cols-2 gap-8">
            {linkSections.map((section) => (
              <div key={section.title}>
                <p className="eyebrow mb-5 block">{section.title}</p>
                <ul className="space-y-3">
                  {section.links.map((l) => (
                    <li key={l.path}>
                      <Link
                        to={l.path}
                        className="group inline-flex items-center gap-1.5 text-white/70 hover:text-[#00FFD1] transition-colors text-base font-medium"
                      >
                        {l.name}
                        <ArrowUpRight
                          size={14}
                          className="opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all"
                        />
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Social */}
          <div className="lg:col-span-2">
            <p className="eyebrow mb-5 block">Follow</p>
            <div className="flex gap-3">
              <a
                href="https://www.linkedin.com/company/deft-experiences/?viewAsMember=true"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className="w-11 h-11 rounded-full glass-panel flex items-center justify-center text-white/70 hover:text-[#00FFD1] hover:border-[#00FFD1]/40 transition-all"
                data-testid="footer-linkedin"
              >
                <Linkedin size={18} />
              </a>
              <a
                href="https://www.instagram.com/deft_experiences?igsh=MWYyNjNkOHg3d2lqMQ=="
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="w-11 h-11 rounded-full glass-panel flex items-center justify-center text-white/70 hover:text-[#00FFD1] hover:border-[#00FFD1]/40 transition-all"
                data-testid="footer-instagram"
              >
                <Instagram size={18} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom row */}
        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="body-small text-white/40">© 2026 Deft Experiences. All rights reserved</p>
          <p className="body-small text-white/40">Crafted with care · Built for the curious few</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
